import { isFlagEnabled } from "js/utilities";
import DeprecatedInsuredCard from "./DeprecatedInsuredCard";
import { default as ReleasingInsuredCard } from "./InsuredCard";
import { useTranslation } from "react-i18next";

const InsuredCard = ({ insureds, effectiveDate, policyDetail }) => {
  const { t } = useTranslation();
  if (!isFlagEnabled("ENABLE_RATE_CLASS")) {
    return (
      <DeprecatedInsuredCard
        insureds={insureds}
        effectiveDate={effectiveDate}
        policyDetail={policyDetail}
      />
    );
  }

  return (
    <ReleasingInsuredCard
      cardTitle={t("AgentInsuredCard-releasinginsuredCard-title")}
      effectiveDate={effectiveDate}
      policyDetail={policyDetail}
    />
  );
};

export default InsuredCard;
